import { CopyProperties } from 'src/app/shared/decorator/copy-properties.decorator';
import { Program } from './program.model';

@CopyProperties()
export class SIP {
  program: Program;
  minCycleLength: number;
  maxCycleLength: number;
  maxContinuousNoninvestmentCycle: number;
  maxNoncontinuousNoninvestmentCycle: number;
  minAmount: number;
  lastTransferDay: number;
  isFixedLastTransferDay: boolean;
  isEnable: boolean;
  isFixedRegisterAmount: boolean;
  vsdCode: string;
  sipCode: string;
  additionalNote: string;
  additionalNoteEn: string;
  isFeeFromFirstTransaction: boolean;
  isFeeFromFirstTransactionBreakSip: boolean;
  feeBuys: any[] = [];
  feeSells: any[] = [];
  feePenalty: any[] = [];
  constructor(
    params?: any
  ) {
    this.program = new Program();
    this.minCycleLength = 0;
    this.maxCycleLength = 0;
    this.maxNoncontinuousNoninvestmentCycle = null;
    this.maxContinuousNoninvestmentCycle = 0;
    this.minAmount = 0;
    this.lastTransferDay = 0;;
    this.isFixedLastTransferDay = false;
    this.isEnable = false;
    this.vsdCode = '';
    this.sipCode = '';
    this.additionalNote = '';
    this.additionalNoteEn = '';
    this.isFeeFromFirstTransaction = false;
    this.isFixedRegisterAmount = false;
    this.isFeeFromFirstTransactionBreakSip = false;
    this.feeBuys = [];
    this.feeSells = [];
    this.feePenalty = [];
  }
}
